<!-- Page Header -->
<div class="m-4 flex flex-col overflow-x-auto">
  <h1 class="text-2xl font-bold text-gray-800 flex items-center gap-2 mb-4">
    <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px;">account_balance_wallet</mat-icon>
    Movimientos de Usuario
  </h1>

  <!-- User Info Card -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <div class="flex items-center gap-2">
        <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">person</mat-icon>
        <span style="font-weight: 700; color: #1e5a3f; font-size: 1.05rem;">Informacion del Usuario</span>
      </div>
    </div>
    <div class="p-5">
      <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Nombre</span>
          <span class="text-sm font-bold text-gray-800">{{userInfo?.nombre}} {{userInfo?.apellidos}}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">ID Usuario</span>
          <span class="text-sm font-mono font-bold text-gray-800">{{userInfo?.usuarioId}}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Documento</span>
          <span class="text-sm font-bold text-gray-800">{{userInfo?.tipoId}} - {{formatDocument()}}</span>
        </div>
        <div class="flex flex-col gap-1">
          <span class="text-xs font-semibold text-gray-500 uppercase tracking-wide">Email</span>
          <span class="text-sm font-bold text-gray-800 break-all">{{userInfo?.email}}</span>
        </div>
      </div>
      <div *ngIf="this.validUser" class="mt-3 pt-3 border-t border-gray-100">
        <span class="px-3 py-1 text-xs font-semibold rounded-full"
          [style.background]="((userInfo?.canAddPayers) && userInfo?.canAddPayers===1) ? '#f0fdf4' : '#fef2f2'"
          [style.color]="((userInfo?.canAddPayers) && userInfo?.canAddPayers===1) ? '#166534' : '#991b1b'">
          {{((userInfo?.canAddPayers) && userInfo?.canAddPayers===1) ? "El usuario puede agregar pagadores":"El usuario NO puede agregar pagadores"}}
        </span>
      </div>
    </div>
  </div>

  <!-- Tabs CLP / VES / USDT -->
  <mat-tab-group class="balance-tabs">

    <!-- Tab CLP (solo NO VE) -->
    <mat-tab *ngIf="userInfo?.tipoId !== 'VE'">
      <ng-template matTabLabel>
        <strong>Saldo CLP</strong>
      </ng-template>
      <div class="tab-content">

        <!-- Balance CLP Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 24px; border-bottom: 2px solid #bbf7d0;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">account_balance</mat-icon>
              <span style="font-weight: 700; color: #1e5a3f; font-size: 0.95rem;">Balance en CLP</span>
            </div>
          </div>
          <div class="p-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              <!-- Balance Info -->
              <div>
                <div class="flex items-center gap-3 mb-3">
                  <span class="text-sm font-semibold text-gray-600">Saldo:</span>
                  <span style="font-weight: 800; font-size: 1.3rem; color: #1e5a3f;">{{this.saldoUsuario | currency: '$':'symbol':'1.0-0'}} CLP</span>
                </div>
                <div *ngIf="lineaCreditoDisponible" class="mt-3 p-3 rounded-xl border border-green-200" style="background: #f0fdf4;">
                  <p class="text-sm font-semibold text-green-700 mb-2">Linea de credito disponible</p>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                      <span class="text-xs text-gray-500 font-semibold">Saldo contable:</span>
                      <span class="text-sm font-bold text-gray-800 ml-1">${{saldoContable | currency:'':''}} CLP</span>
                    </div>
                    <div>
                      <span class="text-xs text-gray-500 font-semibold">Sobregiro disponible:</span>
                      <span class="text-sm font-bold text-green-700 ml-1">${{sobregiroDisponible | currency:'':''}} CLP</span>
                    </div>
                  </div>
                </div>
                <div *ngIf="lineaCreditoBloqueada" class="mt-3 p-3 rounded-xl border border-red-200" style="background: #fef2f2;">
                  <p class="text-sm font-semibold text-red-700 mb-2">Linea de credito bloqueada</p>
                  <div class="grid grid-cols-1 sm:grid-cols-2 gap-2">
                    <div>
                      <span class="text-xs text-gray-500 font-semibold">Saldo contable:</span>
                      <span class="text-sm font-bold text-gray-800 ml-1">${{saldoContable | currency:'':''}} CLP</span>
                    </div>
                    <div>
                      <span class="text-xs text-gray-500 font-semibold">Sobregiro bloqueado:</span>
                      <span class="text-sm font-bold text-red-700 ml-1">${{sobregiroDisponible | currency:'':''}} CLP</span>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Date Range + Search/Download -->
              <div class="flex flex-row flex-wrap gap-3 items-start lg:flex-nowrap">
                <mat-form-field appearance="outline" class="w-full sm:w-1/2 modern-field">
                  <mat-label>Ingresa un rango de fechas</mat-label>
                  <mat-date-range-input [formGroup]="range" [rangePicker]="picker">
                    <input matStartDate formControlName="start" placeholder="Inicio">
                    <input matEndDate formControlName="end" placeholder="Fin">
                  </mat-date-range-input>
                  <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">date_range</mat-icon>
                  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-date-range-picker #picker></mat-date-range-picker>
                </mat-form-field>
                <button type="button" (click)="search()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
                  Buscar
                </button>
                <button type="button" (click)="downloadFile()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">download</mat-icon>
                  Descargar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons CLP -->
        <div class="flex flex-row flex-wrap gap-3 mb-6" *ngIf="this.validUser">
          <!-- Agregar Saldo -->
          <button type="button" matTooltip="Agregar Saldo" aria-label="Agregar Saldo" (click)="agregar()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">attach_money</mat-icon>
            <span class="hidden md:inline">Agregar Saldo</span>
          </button>
          <!-- Debitar Saldo -->
          <button type="button" matTooltip="Debitar Saldo" aria-label="Debitar Saldo" (click)="debitar()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">arrow_downward</mat-icon>
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">attach_money</mat-icon>
            <span class="hidden md:inline">Debitar Saldo</span>
          </button>
          <!-- Quitar Saldo -->
          <button type="button" matTooltip="Quitar Saldo" aria-label="Quitar Saldo" (click)="quitar()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">clear</mat-icon>
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">attach_money</mat-icon>
            <span class="hidden md:inline">Quitar Saldo</span>
          </button>
          <!-- Borrar linea de credito -->
          <button type="button" *ngIf="lineaCreditoDisponible" matTooltip="Borrar linea de credito" aria-label="Borrar linea de credito" (click)="desactivarLineaCredito()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">clear</mat-icon>
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">request_quote</mat-icon>
            <span class="hidden md:inline">Borrar linea de credito</span>
          </button>
          <!-- Linea de credito (Modificar / Crear) -->
          <button type="button" [matTooltip]="lineaCreditoDisponible ? 'Modificar linea de credito' : 'Crear linea de credito'" aria-label="linea de credito" (click)="guardarLineaCredito()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #2563eb; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#1d4ed8'" onmouseout="this.style.background='#2563eb'">
            <mat-icon *ngIf="lineaCreditoDisponible" style="font-size: 18px; width: 18px; height: 18px; color: white;">edit</mat-icon>
            <mat-icon *ngIf="!lineaCreditoDisponible" style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">request_quote</mat-icon>
            <span class="hidden md:inline">{{ lineaCreditoDisponible ? 'Modificar' : 'Crear' }} Linea de Credito</span>
          </button>
        </div>

        <!-- CLP Movements Table Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <div style="background: linear-gradient(135deg, #eff6ff, #dbeafe); padding: 14px 24px; border-bottom: 2px solid #bfdbfe;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #2563eb; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
              <span style="font-weight: 700; color: #1e40af; font-size: 0.95rem;">Movimientos CLP</span>
            </div>
          </div>
          <div class="overflow-auto px-4 py-2">
            <table mat-table *ngIf="dataSource" [dataSource]="dataSource" multiTemplateDataRows class="w-full">
              <ng-container *ngFor="let column of columns" [matColumnDef]="column.columnDef">
                <th mat-header-cell *matHeaderCellDef style="text-align:left">{{column.header}}</th>
                <td mat-cell *matCellDef="let row" style="text-align:left">{{column.cell(row)}}</td>
              </ng-container>
              <ng-container matColumnDef="detalle">
                <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
                <td mat-cell *matCellDef="let element">
                  <button type="button" aria-label="detalle row"
                    (click)="(expandedElement = expandedElement === element ? null : element); $event.stopPropagation()"
                    style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #d1d5db; border-radius: 6px; background: white; cursor: pointer; transition: background 0.2s ease;"
                    onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                    <mat-icon *ngIf="expandedElement !== element" style="font-size: 18px; width: 18px; height: 18px; color: #374151;">keyboard_arrow_down</mat-icon>
                    <mat-icon *ngIf="expandedElement === element" style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">keyboard_arrow_up</mat-icon>
                  </button>
                </td>
              </ng-container>
              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="columnsToDisplayWithExpand.length">
                  <div class="example-element-detail" [@detailExpand]="element == expandedElement ? 'expanded' : 'collapsed'">
                    <div class="w-full p-4 my-2 rounded-xl border border-gray-200" style="background: #f9fafb;">
                      <h3 class="mb-3 text-base font-bold text-gray-800 flex items-center gap-2">
                        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1C593D;">info</mat-icon>
                        Detalle del movimiento
                      </h3>
                      <table *ngIf="element.motivo === 'FONDEO WALLET'">
                        <p *ngIf="!element.remitente" class="text-sm text-gray-600 italic">Fondeo manual</p>
                        <ng-container *ngIf="element.remitente">
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Fecha de transferencia:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.fecha_recepcion}}</td>
                          </tr>
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Hora de transferencia:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.hora_recepcion}}</td>
                          </tr>
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Nombre origen:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.remitente}}</td>
                          </tr>
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">RUT origen:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.rut_origen}}</td>
                          </tr>
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Cuenta origen:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.numeroCuenta}}</td>
                          </tr>
                          <tr>
                            <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Codigo de transferencia:</span></td>
                            <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.codigo_transferencia}}</td>
                          </tr>
                          <ng-container *ngIf="element.cuentaDestino">
                            <tr>
                              <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Cuenta destino:</span></td>
                              <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.cuentaDestino === "27780767"? "Parra Aldazoro SpA":"Aguacate Investments SpA"}}</td>
                            </tr>
                          </ng-container>
                        </ng-container>
                      </table>
                      <table *ngIf="element.tipoTransaccion === 'CRIPTO'">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Beneficiario:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.beneficiario}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Tasa de negociacion:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.tn}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto CLP:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaOrigen | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto USDT:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaDestino | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Wallet TRC20:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800 font-mono break-all">{{element.walletTRC20}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Estado:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.estadoActual}}</td>
                        </tr>
                      </table>
                      <table *ngIf="element.tipoTransaccion === 'ZELLE'">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Beneficiario:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.beneficiarioZelle}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Tasa de negociacion:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.tn}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto CLP:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaOrigen | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto USD:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaDestino | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Estado:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.estadoActual}}</td>
                        </tr>
                      </table>
                      <table *ngIf="element.tipoTransaccion === 'FIAT'">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Beneficiario:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.beneficiario}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Banco:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.banco}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Tasa de negociacion:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.tn}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto CLP:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaOrigen | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto VES:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaDestino | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Estado:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.estadoActual}}</td>
                        </tr>
                      </table>
                      <table *ngIf="element.tipoTransaccion === 'RETIRO'">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Alias:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.aliasRetiro}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Numero de cuenta:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.numeroCuentaRetiro}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Banco:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.banco}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaDestino | number:'1.0-2' }}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Estado:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.estadoActual}}</td>
                        </tr>
                      </table>
                      <table *ngIf="element.motivo.includes('Reversión')">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Motivo:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.motivo}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaOrigen | number:'1.0-2'}}</td>
                        </tr>
                      </table>
                      <table *ngIf="element.motivo === 'AJUSTE DE BALANCE'">
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Motivo:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.motivo}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Monto:</span></td>
                          <td style="padding: 4px 0; color: #1e5a3f;" class="text-sm font-bold">${{element.monedaOrigen | number:'1.0-2'}}</td>
                        </tr>
                        <tr>
                          <td style="width: 200px; padding: 4px 0;"><span class="text-xs font-bold text-gray-600">Estado:</span></td>
                          <td style="padding: 4px 0;" class="text-sm text-gray-800">{{element.estadoActual}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
              <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === element"
                (click)="expandedElement = expandedElement === element ? null : element">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
        </div>

      </div>
    </mat-tab>

    <!-- Tab VES (VE y chilenos con saldo VES) -->
    <mat-tab *ngIf="tieneSaldoVes">
      <ng-template matTabLabel>
        <strong>Saldo VES</strong>
      </ng-template>
      <div class="tab-content">

        <!-- Balance VES Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 24px; border-bottom: 2px solid #bbf7d0;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">account_balance</mat-icon>
              <span style="font-weight: 700; color: #1e5a3f; font-size: 0.95rem;">Balance en VES</span>
            </div>
          </div>
          <div class="p-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              <!-- Balance Info -->
              <div class="flex flex-col gap-3">
                <div class="flex items-center gap-3">
                  <span class="text-sm font-semibold text-gray-600">Saldo Disponible:</span>
                  <span style="font-weight: 800; font-size: 1.3rem; color: #1e5a3f;">Bs. {{this.saldoVES | number:'1.2-2'}}</span>
                </div>
              </div>

              <!-- Date Range + Search/Download -->
              <div class="flex flex-row flex-wrap gap-3 items-start lg:flex-nowrap">
                <mat-form-field appearance="outline" class="w-full sm:w-1/2 modern-field">
                  <mat-label>Ingresa un rango de fechas</mat-label>
                  <mat-date-range-input [formGroup]="rangeVES" [rangePicker]="pickerVes">
                    <input matStartDate formControlName="start" placeholder="Inicio">
                    <input matEndDate formControlName="end" placeholder="Fin">
                  </mat-date-range-input>
                  <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">date_range</mat-icon>
                  <mat-datepicker-toggle matIconSuffix [for]="pickerVes"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerVes></mat-date-range-picker>
                </mat-form-field>
                <button type="button" (click)="searchVES()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
                  Buscar
                </button>
                <button type="button" (click)="downloadFileVES()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">download</mat-icon>
                  Descargar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Success/Error Messages VES -->
        <div *ngIf="successMsgVES" class="mb-4 p-3 bg-green-50 border border-green-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-green-600 text-sm">check_circle</mat-icon>
          <span class="text-green-700 text-sm">{{ successMsgVES }}</span>
        </div>
        <div *ngIf="errorMsgVES && !showManualCreditModalVES && !showManualDebitModalVES" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-red-600 text-sm">error</mat-icon>
          <span class="text-red-700 text-sm">{{ errorMsgVES }}</span>
        </div>

        <!-- Action Buttons VES -->
        <div class="flex flex-row flex-wrap gap-3 mb-6" *ngIf="this.validUser">
          <button type="button" matTooltip="Agregar Saldo VES" aria-label="Agregar Saldo VES" (click)="agregarVES()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
            <span class="hidden md:inline">Agregar Saldo</span>
            <span class="ml-1">VES</span>
          </button>
          <button type="button" matTooltip="Debitar Saldo VES" aria-label="Debitar Saldo VES" (click)="debitarVES()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">remove</mat-icon>
            <span class="hidden md:inline">Debitar Saldo</span>
            <span class="ml-1">VES</span>
          </button>
        </div>

        <!-- VES Movements Table Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 14px 24px; border-bottom: 2px solid #bbf7d0;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
              <span style="font-weight: 700; color: #1e5a3f; font-size: 0.95rem;">Movimientos VES</span>
            </div>
          </div>
          <div class="overflow-auto px-4 py-2">
            <table mat-table [dataSource]="dataSourceVES" class="w-full">
              <ng-container *ngFor="let column of columnsVES; trackBy: trackByColumnDef" [matColumnDef]="column.columnDef">
                <th mat-header-cell *matHeaderCellDef style="text-align:left">{{column.header}}</th>
                <td mat-cell *matCellDef="let row" style="text-align:left">{{column.cell(row)}}</td>
              </ng-container>
              <ng-container matColumnDef="debito">
                <th mat-header-cell *matHeaderCellDef style="text-align:left">Debito</th>
                <td mat-cell *matCellDef="let row" style="text-align:left">
                  <span *ngIf="row.debitVes > 0; else emptyDebit">
                    {{ row.debitVes | number:'1.2-2' }}
                    <mat-icon
                      *ngIf="isSwapBeneficiarioRow(row)"
                      matTooltip="Monto pagado al beneficiario por la cuenta de trabajo. No afecta el saldo VES del usuario."
                      matTooltipPosition="above"
                      style="font-size:14px; width:14px; height:14px; vertical-align:middle; color:#6b7280; cursor:help;">
                      info
                    </mat-icon>
                  </span>
                  <ng-template #emptyDebit>-</ng-template>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplayVES"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplayVES;" [attr.data-id]="row.id"></tr>

              <!-- No data row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="columnsToDisplayVES.length" style="text-align: center; padding: 20px; color: #6b7280; font-size: 0.9rem;">
                  No se encontraron movimientos VES para el rango de fechas seleccionado
                </td>
              </tr>
            </table>

            <!-- Paginator VES -->
            <mat-paginator
              *ngIf="totalMovimientosVES > 0"
              [length]="totalMovimientosVES"
              [pageSize]="pageSizeVES"
              [pageSizeOptions]="[10, 20, 50, 100]"
              [pageIndex]="currentPageVES - 1"
              (page)="onPageChangeVES($event)"
              showFirstLastButtons
              aria-label="Seleccionar pagina de movimientos VES">
            </mat-paginator>
          </div>
        </div>

      </div>
    </mat-tab>

    <!-- Tab USDT -->
    <mat-tab>
      <ng-template matTabLabel>
        <strong>Saldo USDT</strong>
      </ng-template>
      <div class="tab-content">

        <!-- Balance USDT Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
          <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 14px 24px; border-bottom: 2px solid #fde68a;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #92400e; font-size: 20px; width: 20px; height: 20px;">currency_exchange</mat-icon>
              <span style="font-weight: 700; color: #92400e; font-size: 0.95rem;">Balance en USDT</span>
            </div>
          </div>
          <div class="p-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
              <!-- Balance Info -->
              <div class="flex flex-col gap-3">
                <div class="flex items-center gap-3">
                  <span class="text-sm font-semibold text-gray-600">Saldo Total:</span>
                  <span style="font-weight: 800; font-size: 1.1rem; color: #1e5a3f;">{{this.saldoUSDTTotal | number:'1.2-2'}} USDT</span>
                </div>
                <div class="flex items-center gap-3">
                  <span class="text-sm font-semibold text-gray-600">Saldo Bloqueado:</span>
                  <span style="font-weight: 700; font-size: 1rem; color: #dc2626;">{{this.saldoUSDTBloqueado | number:'1.2-2'}} USDT</span>
                </div>
                <div class="flex items-center gap-3">
                  <span class="text-sm font-semibold text-gray-600">Saldo Disponible:</span>
                  <span style="font-weight: 800; font-size: 1.1rem; color: #16a34a;">{{this.saldoUSDTDisponible | number:'1.2-2'}} USDT</span>
                </div>
              </div>

              <!-- Date Range + Search/Download -->
              <div class="flex flex-row flex-wrap gap-3 items-start lg:flex-nowrap">
                <mat-form-field appearance="outline" class="w-full sm:w-1/2 modern-field">
                  <mat-label>Ingresa un rango de fechas</mat-label>
                  <mat-date-range-input [formGroup]="range" [rangePicker]="pickerUsdt">
                    <input matStartDate formControlName="start" placeholder="Inicio">
                    <input matEndDate formControlName="end" placeholder="Fin">
                  </mat-date-range-input>
                  <mat-icon matPrefix style="color: #6b7280; margin-right: 4px;">date_range</mat-icon>
                  <mat-datepicker-toggle matIconSuffix [for]="pickerUsdt"></mat-datepicker-toggle>
                  <mat-date-range-picker #pickerUsdt></mat-date-range-picker>
                </mat-form-field>
                <button type="button" (click)="searchUSDT()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
                  Buscar
                </button>
                <button type="button" (click)="downloadFileUSDT()"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease; height: 56px; white-space: nowrap;"
                  onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
                  <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">download</mat-icon>
                  Descargar
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Action Buttons USDT.
             Abono (Agregar): SOLO el operador autorizado (carlos@aguacatecambios.com,
             validado por email de Cognito → `puedeAbonarUsdt`).
             Débito: sigue habilitado para la lista `CORREOS_AUT` (`validUser`). -->
        <div class="flex flex-row flex-wrap gap-3 mb-6" *ngIf="this.validUser || this.puedeAbonarUsdt">
          <button type="button" *ngIf="this.puedeAbonarUsdt" matTooltip="Agregar Saldo USDT" aria-label="Agregar Saldo USDT" (click)="agregarUSDT()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">add</mat-icon>
            <span class="hidden md:inline">Agregar Saldo</span>
            <span class="ml-1">USDT</span>
          </button>
          <button type="button" *ngIf="this.validUser" matTooltip="Debitar Saldo USDT" aria-label="Debitar Saldo USDT" (click)="debitarUSDT()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 10px 20px; background: #ea580c; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#c2410c'" onmouseout="this.style.background='#ea580c'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">remove</mat-icon>
            <span class="hidden md:inline">Debitar Saldo</span>
            <span class="ml-1">USDT</span>
          </button>
        </div>

        <!-- USDT Movements Table Card -->
        <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden">
          <div style="background: linear-gradient(135deg, #fefce8, #fef9c3); padding: 14px 24px; border-bottom: 2px solid #fde68a;">
            <div class="flex items-center gap-2">
              <mat-icon style="color: #92400e; font-size: 20px; width: 20px; height: 20px;">receipt_long</mat-icon>
              <span style="font-weight: 700; color: #92400e; font-size: 0.95rem;">Movimientos USDT</span>
            </div>
          </div>
          <div class="overflow-auto px-4 py-2">
            <table mat-table [dataSource]="dataSourceUSDT" class="w-full">
              <ng-container *ngFor="let column of columnsUSDT; trackBy: trackByColumnDef" [matColumnDef]="column.columnDef">
                <th mat-header-cell *matHeaderCellDef style="text-align:left">{{column.header}}</th>
                <td mat-cell *matCellDef="let row" style="text-align:left">{{column.cell(row)}}</td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="columnsToDisplayUSDT"></tr>
              <tr mat-row *matRowDef="let row; columns: columnsToDisplayUSDT;" [attr.data-id]="row.id"></tr>

              <!-- No data row -->
              <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell" [attr.colspan]="columnsToDisplayUSDT.length" style="text-align: center; padding: 20px; color: #6b7280; font-size: 0.9rem;">
                  No se encontraron movimientos USDT para el rango de fechas seleccionado
                </td>
              </tr>
            </table>

            <!-- Paginator USDT -->
            <mat-paginator
              *ngIf="totalMovimientosUSDT > 0"
              [length]="totalMovimientosUSDT"
              [pageSize]="pageSizeUSDT"
              [pageSizeOptions]="[10, 20, 50, 100]"
              [pageIndex]="currentPageUSDT - 1"
              (page)="onPageChangeUSDT($event)"
              showFirstLastButtons
              aria-label="Seleccionar pagina de movimientos USDT">
            </mat-paginator>
          </div>
        </div>

      </div>
    </mat-tab>
  </mat-tab-group>
</div>

<!-- Modal: Agregar Saldo USDT Manual -->
<div *ngIf="showManualCreditModalUSDT" class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);" (click)="closeManualCreditModalUSDT()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header con gradiente verde -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
      <h3 class="text-lg font-bold flex items-center gap-2" style="color: #1e5a3f; margin: 0;">
        <mat-icon style="color: #16a34a; font-size: 24px; width: 24px; height: 24px;">add_circle</mat-icon>
        <span *ngIf="!confirmStepCreditUSDT">Agregar Saldo Manual de USDT</span>
        <span *ngIf="confirmStepCreditUSDT">Confirmar Carga de Saldo USDT</span>
      </h3>
    </div>

    <!-- ============ PASO 1: Formulario ============ -->
    <ng-container *ngIf="!confirmStepCreditUSDT">
      <div class="px-6 py-4">
        <!-- Error message -->
        <div *ngIf="errorMsgUSDT" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-red-600 text-sm">error</mat-icon>
          <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgUSDT }}</span>
        </div>

        <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-blue-600 text-sm">info</mat-icon>
          <div class="text-blue-700 text-sm">
            <p class="font-semibold">Esta seguro que desea agregar saldo USDT manualmente?</p>
            <p class="text-xs mt-1">Esta accion agregara USDT al saldo disponible del usuario y se registrara en el cardex.</p>
          </div>
        </div>

        <div *ngIf="userInfo" class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
          <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">person</mat-icon>
            Informacion del Usuario
          </h4>
          <div class="text-sm space-y-2">
            <div class="bg-white p-3 rounded-xl border border-green-100">
              <div class="flex items-center gap-2 mb-2">
                <mat-icon class="text-blue-600 text-sm">person</mat-icon>
                <span class="font-semibold text-gray-700">Usuario</span>
              </div>
              <div class="ml-6 space-y-1">
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">Nombre:</span>
                  <span class="font-medium text-xs">{{ userInfo.nombre || 'N/A' }} {{ userInfo.apellidos || '' }}</span>
                </div>
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">Email:</span>
                  <span class="font-medium text-xs break-all">{{ userInfo.email || 'N/A' }}</span>
                </div>
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">ID:</span>
                  <span class="font-mono text-xs text-gray-500">{{ userInfo.usuarioId }}</span>
                </div>
              </div>
            </div>
            <div class="flex justify-between pt-2 border-t">
              <span class="text-gray-600 font-semibold">Saldo Actual USDT:</span>
              <span class="font-bold" style="color: #1e5a3f;">{{ saldoUSDTDisponible | number:'1.2-2' }} USDT</span>
            </div>
          </div>
        </div>

        <form [formGroup]="manualCreditFormUSDT">
          <div class="mb-4">
            <label for="amountCreditUSDT" class="block text-sm font-medium text-gray-700 mb-2">
              Monto a Agregar (USDT) <span class="text-red-500">*</span>
            </label>
            <input
              id="amountCreditUSDT"
              type="text"
              inputmode="decimal"
              placeholder="Ej: 100,00"
              class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
              [class.border-red-500]="manualCreditFormUSDT.get('amount')?.invalid && manualCreditFormUSDT.get('amount')?.touched"
              (input)="onAmountInputCreditUSDT($event)"
            />
            <div *ngIf="manualCreditFormUSDT.get('amount')?.invalid && manualCreditFormUSDT.get('amount')?.touched"
                 class="text-red-500 text-xs mt-1">
              <span *ngIf="manualCreditFormUSDT.get('amount')?.errors?.['required']">El monto es requerido</span>
              <span *ngIf="manualCreditFormUSDT.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
              <span *ngIf="manualCreditFormUSDT.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
            </div>
            <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. Maximo 2 decimales.</p>
          </div>

          <div class="mb-4">
            <label for="reasonCreditUSDT" class="block text-sm font-medium text-gray-700 mb-2">
              Motivo <span class="text-red-500">*</span>
            </label>
            <textarea
              id="reasonCreditUSDT"
              formControlName="reason"
              rows="3"
              placeholder="Ej: Deposito no registrado, correccion de saldo, bonificacion, compensacion, etc."
              class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
              [class.border-red-500]="manualCreditFormUSDT.get('reason')?.invalid && manualCreditFormUSDT.get('reason')?.touched"
            ></textarea>
            <div *ngIf="manualCreditFormUSDT.get('reason')?.invalid && manualCreditFormUSDT.get('reason')?.touched"
                 class="text-red-500 text-xs mt-1">
              <span *ngIf="manualCreditFormUSDT.get('reason')?.errors?.['required']">El motivo es requerido</span>
              <span *ngIf="manualCreditFormUSDT.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 5 caracteres</span>
            </div>
          </div>
        </form>
      </div>
      <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
        <button
          type="button"
          (click)="goToConfirmStepCreditUSDT()"
          [disabled]="loadingUSDT || manualCreditFormUSDT.invalid"
          [style.opacity]="(loadingUSDT || manualCreditFormUSDT.invalid) ? '0.5' : '1'"
          [style.cursor]="(loadingUSDT || manualCreditFormUSDT.invalid) ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">arrow_forward</mat-icon>
          Agregar Saldo
        </button>
        <button
          type="button"
          (click)="closeManualCreditModalUSDT()"
          [disabled]="loadingUSDT"
          [style.opacity]="loadingUSDT ? '0.5' : '1'"
          [style.cursor]="loadingUSDT ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- ============ PASO 2: Confirmacion ============ -->
    <ng-container *ngIf="confirmStepCreditUSDT">
      <div class="px-6 py-4">
        <!-- Error message -->
        <div *ngIf="errorMsgUSDT" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-red-600 text-sm">error</mat-icon>
          <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgUSDT }}</span>
        </div>

        <div class="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-amber-600 text-sm">warning</mat-icon>
          <div class="text-amber-700 text-sm">
            <p class="font-semibold">Verifique los datos antes de confirmar</p>
            <p class="text-xs mt-1">Reescriba el monto para confirmar que es correcto.</p>
          </div>
        </div>

        <!-- Resumen de la operacion -->
        <div class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
          <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">receipt_long</mat-icon>
            Resumen de la Operacion
          </h4>
          <div class="text-sm space-y-2">
            <div class="flex justify-between">
              <span class="text-gray-600">Email:</span>
              <span class="font-medium break-all text-right">{{ userInfo?.email || 'N/A' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Monto a Agregar:</span>
              <span class="font-bold text-lg" style="color: #1C593D;">{{ manualCreditFormUSDT.get('amount')?.value | number:'1.2-2' }} USDT</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Motivo:</span>
              <span class="font-medium text-right" style="max-width: 60%;">{{ manualCreditFormUSDT.get('reason')?.value }}</span>
            </div>
          </div>
        </div>

        <!-- Campo de confirmacion de monto -->
        <div class="mb-4">
          <label for="confirmAmountCreditUSDT" class="block text-sm font-medium text-gray-700 mb-2">
            Reescriba el monto para confirmar <span class="text-red-500">*</span>
          </label>
          <input
            id="confirmAmountCreditUSDT"
            type="text"
            inputmode="decimal"
            placeholder="Ej: 100,00"
            class="w-full px-3 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
            [class.border-red-500]="confirmAmountMismatch"
            [class.border-green-500]="confirmAmountMatchesCreditUSDT"
            [class.border-gray-300]="!confirmAmountMismatch && !confirmAmountMatchesCreditUSDT"
            (input)="onConfirmAmountInputCreditUSDT($event)"
          />
          <div *ngIf="confirmAmountMismatch" class="text-red-500 text-xs mt-1 flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">error</mat-icon>
            Los montos no coinciden. Verifique e intente de nuevo.
          </div>
          <div *ngIf="confirmAmountMatchesCreditUSDT" class="text-green-600 text-xs mt-1 flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">check_circle</mat-icon>
            Los montos coinciden.
          </div>
        </div>
      </div>
      <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
        <button
          type="button"
          (click)="executeManualCreditUSDT()"
          [disabled]="!confirmAmountMatchesCreditUSDT || isProcessingCreditUSDT || creditRetryAfterSecondsUSDT > 0"
          [style.opacity]="(!confirmAmountMatchesCreditUSDT || isProcessingCreditUSDT || creditRetryAfterSecondsUSDT > 0) ? '0.5' : '1'"
          [style.cursor]="(!confirmAmountMatchesCreditUSDT || isProcessingCreditUSDT || creditRetryAfterSecondsUSDT > 0) ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="!isProcessingCreditUSDT && creditRetryAfterSecondsUSDT === 0">check_circle</mat-icon>
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="creditRetryAfterSecondsUSDT > 0">schedule</mat-icon>
          <mat-spinner diameter="16" *ngIf="isProcessingCreditUSDT" class="inline-block"></mat-spinner>
          <span *ngIf="!isProcessingCreditUSDT && creditRetryAfterSecondsUSDT === 0">Confirmar</span>
          <span *ngIf="isProcessingCreditUSDT">Procesando...</span>
          <span *ngIf="creditRetryAfterSecondsUSDT > 0">Espera {{ creditRetryAfterSecondsUSDT }}s</span>
        </button>
        <button
          type="button"
          (click)="goBackFromConfirmCreditUSDT()"
          [disabled]="isProcessingCreditUSDT"
          [style.opacity]="isProcessingCreditUSDT ? '0.5' : '1'"
          [style.cursor]="isProcessingCreditUSDT ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
          Volver
        </button>
      </div>
    </ng-container>
  </div>
</div>

<!-- Modal: Debitar Saldo USDT Manual -->
<div *ngIf="showManualDebitModalUSDT" class="fixed inset-0 flex items-center justify-center z-50" style="background: rgba(0,0,0,0.5);" (click)="closeManualDebitModalUSDT()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header con gradiente rojo/naranja -->
    <div style="background: linear-gradient(135deg, #fef2f2, #fee2e2); padding: 20px 24px; border-bottom: 2px solid #fecaca;">
      <h3 class="text-lg font-bold flex items-center gap-2" style="color: #991b1b; margin: 0;">
        <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">remove_circle</mat-icon>
        Debitar Saldo Manual de USDT
      </h3>
    </div>
    <div class="px-6 py-4">
      <!-- Error message -->
      <div *ngIf="errorMsgUSDT" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgUSDT }}</span>
      </div>

      <div class="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-2">
        <mat-icon class="text-orange-600 text-sm">warning</mat-icon>
        <div class="text-orange-700 text-sm">
          <p class="font-semibold">Esta seguro que desea debitar saldo USDT manualmente?</p>
          <p class="text-xs mt-1">Esta accion quitara USDT del saldo disponible del usuario y se registrara en el cardex.</p>
        </div>
      </div>

      <div *ngIf="userInfo" class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
        <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">person</mat-icon>
          Informacion del Usuario
        </h4>
        <div class="text-sm space-y-2">
          <div class="bg-white p-3 rounded-xl border border-red-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-blue-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ userInfo.nombre || 'N/A' }} {{ userInfo.apellidos || '' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ userInfo.email || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ userInfo.usuarioId }}</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between pt-2 border-t">
            <span class="text-gray-600 font-semibold">Saldo Disponible USDT:</span>
            <span class="font-bold text-green-600">{{ saldoUSDTDisponible | number:'1.2-2' }} USDT</span>
          </div>
        </div>
      </div>

      <form [formGroup]="manualDebitFormUSDT">
        <div class="mb-4">
          <label for="amountDebitUSDT" class="block text-sm font-medium text-gray-700 mb-2">
            Monto a Debitar (USDT) <span class="text-red-500">*</span>
          </label>
          <input
            id="amountDebitUSDT"
            type="text"
            inputmode="decimal"
            placeholder="Ej: 100,00"
            class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitFormUSDT.get('amount')?.invalid && manualDebitFormUSDT.get('amount')?.touched"
            (input)="onAmountInputDebitUSDT($event)"
          />
          <div *ngIf="manualDebitFormUSDT.get('amount')?.invalid && manualDebitFormUSDT.get('amount')?.touched"
               class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitFormUSDT.get('amount')?.errors?.['required']">El monto es requerido</span>
            <span *ngIf="manualDebitFormUSDT.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
            <span *ngIf="manualDebitFormUSDT.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. Maximo 2 decimales.</p>
        </div>

        <div class="mb-4">
          <label for="reasonDebitUSDT" class="block text-sm font-medium text-gray-700 mb-2">
            Motivo <span class="text-red-500">*</span>
          </label>
          <textarea
            id="reasonDebitUSDT"
            formControlName="reason"
            rows="3"
            placeholder="Ej: Ajuste por error en deposito, correccion de saldo, retiro no procesado, etc."
            class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitFormUSDT.get('reason')?.invalid && manualDebitFormUSDT.get('reason')?.touched"
          ></textarea>
          <div *ngIf="manualDebitFormUSDT.get('reason')?.invalid && manualDebitFormUSDT.get('reason')?.touched"
               class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitFormUSDT.get('reason')?.errors?.['required']">El motivo es requerido</span>
            <span *ngIf="manualDebitFormUSDT.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 5 caracteres</span>
          </div>
        </div>
      </form>
    </div>
    <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
      <button
        type="button"
        (click)="executeManualDebitUSDT()"
        [disabled]="loadingUSDT || manualDebitFormUSDT.invalid || isProcessingDebitUSDT || debitRetryAfterSecondsUSDT > 0"
        [style.opacity]="(loadingUSDT || manualDebitFormUSDT.invalid || isProcessingDebitUSDT || debitRetryAfterSecondsUSDT > 0) ? '0.5' : '1'"
        [style.cursor]="(loadingUSDT || manualDebitFormUSDT.invalid || isProcessingDebitUSDT || debitRetryAfterSecondsUSDT > 0) ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
        onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="!isProcessingDebitUSDT && debitRetryAfterSecondsUSDT === 0">remove_circle</mat-icon>
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="debitRetryAfterSecondsUSDT > 0">schedule</mat-icon>
        <mat-spinner diameter="16" *ngIf="isProcessingDebitUSDT" class="inline-block"></mat-spinner>
        <span *ngIf="!isProcessingDebitUSDT && debitRetryAfterSecondsUSDT === 0">Debitar Saldo</span>
        <span *ngIf="isProcessingDebitUSDT">Procesando...</span>
        <span *ngIf="debitRetryAfterSecondsUSDT > 0">Espera {{ debitRetryAfterSecondsUSDT }}s</span>
      </button>
      <button
        type="button"
        (click)="closeManualDebitModalUSDT()"
        [disabled]="loadingUSDT"
        [style.opacity]="loadingUSDT ? '0.5' : '1'"
        [style.cursor]="loadingUSDT ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>

<!-- Modal: Agregar Saldo VES Manual -->
<div *ngIf="showManualCreditModalVES" class="fixed inset-0 z-50 flex justify-center items-center"
  style="background: rgba(0,0,0,0.5);" (click)="closeManualCreditModalVES()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 20px 24px; border-bottom: 2px solid #bbf7d0;">
      <h3 class="text-lg font-bold flex items-center gap-2" style="color: #1e5a3f; margin: 0;">
        <mat-icon style="color: #16a34a; font-size: 24px; width: 24px; height: 24px;">add_circle</mat-icon>
        <span *ngIf="!confirmStepCreditVES">Agregar Saldo Manual de VES</span>
        <span *ngIf="confirmStepCreditVES">Confirmar Carga de Saldo VES</span>
      </h3>
    </div>

    <!-- PASO 1: Formulario -->
    <ng-container *ngIf="!confirmStepCreditVES">
      <div class="px-6 py-4">
        <div *ngIf="errorMsgVES" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-red-600 text-sm">error</mat-icon>
          <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgVES }}</span>
        </div>

        <div class="mb-4 p-3 bg-blue-50 border border-blue-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-blue-600 text-sm">info</mat-icon>
          <div class="text-blue-700 text-sm">
            <p class="font-semibold">Esta seguro que desea agregar saldo VES manualmente?</p>
            <p class="text-xs mt-1">Esta accion agregara VES al saldo disponible del usuario y se registrara en el cardex.</p>
          </div>
        </div>

        <div *ngIf="userInfo" class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
          <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">person</mat-icon>
            Informacion del Usuario
          </h4>
          <div class="text-sm space-y-2">
            <div class="bg-white p-3 rounded-xl border border-green-100">
              <div class="flex items-center gap-2 mb-2">
                <mat-icon class="text-blue-600 text-sm">person</mat-icon>
                <span class="font-semibold text-gray-700">Usuario</span>
              </div>
              <div class="ml-6 space-y-1">
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">Nombre:</span>
                  <span class="font-medium text-xs">{{ userInfo.nombre || 'N/A' }} {{ userInfo.apellidos || '' }}</span>
                </div>
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">Email:</span>
                  <span class="font-medium text-xs break-all">{{ userInfo.email || 'N/A' }}</span>
                </div>
                <div class="flex items-start">
                  <span class="text-gray-600 text-xs w-16">ID:</span>
                  <span class="font-mono text-xs text-gray-500">{{ userInfo.usuarioId }}</span>
                </div>
              </div>
            </div>
            <div class="flex justify-between pt-2 border-t">
              <span class="text-gray-600 font-semibold">Saldo Actual VES:</span>
              <span class="font-bold" style="color: #1e5a3f;">Bs. {{ saldoVES | number:'1.2-2' }}</span>
            </div>
          </div>
        </div>

        <form [formGroup]="manualCreditFormVES">
          <div class="mb-4">
            <label for="amountCreditVES" class="block text-sm font-medium text-gray-700 mb-2">
              Monto a Agregar (VES) <span class="text-red-500">*</span>
            </label>
            <input
              id="amountCreditVES"
              type="text"
              inputmode="decimal"
              placeholder="Ej: 1000,00"
              class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
              [class.border-red-500]="manualCreditFormVES.get('amount')?.invalid && manualCreditFormVES.get('amount')?.touched"
              (input)="onAmountInputCreditVES($event)"
            />
            <div *ngIf="manualCreditFormVES.get('amount')?.invalid && manualCreditFormVES.get('amount')?.touched"
                 class="text-red-500 text-xs mt-1">
              <span *ngIf="manualCreditFormVES.get('amount')?.errors?.['required']">El monto es requerido</span>
              <span *ngIf="manualCreditFormVES.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
              <span *ngIf="manualCreditFormVES.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
            </div>
            <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. Maximo 2 decimales.</p>
          </div>

          <div class="mb-4">
            <label for="reasonCreditVES" class="block text-sm font-medium text-gray-700 mb-2">
              Motivo <span class="text-red-500">*</span>
            </label>
            <textarea
              id="reasonCreditVES"
              formControlName="reason"
              rows="3"
              placeholder="Ej: Deposito no registrado, correccion de saldo, bonificacion, compensacion, etc."
              class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
              [class.border-red-500]="manualCreditFormVES.get('reason')?.invalid && manualCreditFormVES.get('reason')?.touched"
            ></textarea>
            <div *ngIf="manualCreditFormVES.get('reason')?.invalid && manualCreditFormVES.get('reason')?.touched"
                 class="text-red-500 text-xs mt-1">
              <span *ngIf="manualCreditFormVES.get('reason')?.errors?.['required']">El motivo es requerido</span>
              <span *ngIf="manualCreditFormVES.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 10 caracteres</span>
            </div>
          </div>
        </form>
      </div>
      <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
        <button
          type="button"
          (click)="goToConfirmStepCreditVES()"
          [disabled]="manualCreditFormVES.invalid"
          [style.opacity]="manualCreditFormVES.invalid ? '0.5' : '1'"
          [style.cursor]="manualCreditFormVES.invalid ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;">arrow_forward</mat-icon>
          Agregar Saldo
        </button>
        <button
          type="button"
          (click)="closeManualCreditModalVES()"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
          Cancelar
        </button>
      </div>
    </ng-container>

    <!-- PASO 2: Confirmacion -->
    <ng-container *ngIf="confirmStepCreditVES">
      <div class="px-6 py-4">
        <div *ngIf="errorMsgVES" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-red-600 text-sm">error</mat-icon>
          <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgVES }}</span>
        </div>

        <div class="mb-4 p-3 bg-amber-50 border border-amber-200 rounded-xl flex items-start gap-2">
          <mat-icon class="text-amber-600 text-sm">warning</mat-icon>
          <div class="text-amber-700 text-sm">
            <p class="font-semibold">Verifique los datos antes de confirmar</p>
            <p class="text-xs mt-1">Reescriba el monto para confirmar que es correcto.</p>
          </div>
        </div>

        <!-- Resumen de la operacion -->
        <div class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
          <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
            <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #1C593D;">receipt_long</mat-icon>
            Resumen de la Operacion
          </h4>
          <div class="text-sm space-y-2">
            <div class="flex justify-between">
              <span class="text-gray-600">Email:</span>
              <span class="font-medium break-all text-right">{{ userInfo?.email || 'N/A' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Monto a Agregar:</span>
              <span class="font-bold text-lg" style="color: #1C593D;">Bs. {{ manualCreditFormVES.get('amount')?.value | number:'1.2-2' }}</span>
            </div>
            <div class="flex justify-between">
              <span class="text-gray-600">Motivo:</span>
              <span class="font-medium text-right" style="max-width: 60%;">{{ manualCreditFormVES.get('reason')?.value }}</span>
            </div>
          </div>
        </div>

        <!-- Campo de confirmacion de monto -->
        <div class="mb-4">
          <label for="confirmAmountCreditVES" class="block text-sm font-medium text-gray-700 mb-2">
            Reescriba el monto para confirmar <span class="text-red-500">*</span>
          </label>
          <input
            id="confirmAmountCreditVES"
            type="text"
            inputmode="decimal"
            placeholder="Ej: 1000,00"
            class="w-full px-3 py-2 border rounded-xl focus:outline-none focus:ring-2 focus:ring-green-500"
            [class.border-red-500]="confirmAmountMismatchVES"
            [class.border-green-500]="confirmAmountMatchesCreditVES"
            [class.border-gray-300]="!confirmAmountMismatchVES && !confirmAmountMatchesCreditVES"
            (input)="onConfirmAmountInputCreditVES($event)"
          />
          <div *ngIf="confirmAmountMismatchVES" class="text-red-500 text-xs mt-1 flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">error</mat-icon>
            Los montos no coinciden. Verifique e intente de nuevo.
          </div>
          <div *ngIf="confirmAmountMatchesCreditVES" class="text-green-600 text-xs mt-1 flex items-center gap-1">
            <mat-icon style="font-size: 14px; width: 14px; height: 14px;">check_circle</mat-icon>
            Los montos coinciden.
          </div>
        </div>
      </div>
      <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
        <button
          type="button"
          (click)="executeManualCreditVES()"
          [disabled]="!confirmAmountMatchesCreditVES || isProcessingCreditVES"
          [style.opacity]="(!confirmAmountMatchesCreditVES || isProcessingCreditVES) ? '0.5' : '1'"
          [style.cursor]="(!confirmAmountMatchesCreditVES || isProcessingCreditVES) ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="!isProcessingCreditVES">check_circle</mat-icon>
          <mat-spinner diameter="16" *ngIf="isProcessingCreditVES" class="inline-block"></mat-spinner>
          <span *ngIf="!isProcessingCreditVES">Confirmar</span>
          <span *ngIf="isProcessingCreditVES">Procesando...</span>
        </button>
        <button
          type="button"
          (click)="goBackFromConfirmCreditVES()"
          [disabled]="isProcessingCreditVES"
          [style.opacity]="isProcessingCreditVES ? '0.5' : '1'"
          [style.cursor]="isProcessingCreditVES ? 'not-allowed' : 'pointer'"
          style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
          onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">arrow_back</mat-icon>
          Volver
        </button>
      </div>
    </ng-container>
  </div>
</div>

<!-- Modal: Debitar Saldo VES Manual -->
<div *ngIf="showManualDebitModalVES" class="fixed inset-0 flex items-center justify-center z-50" style="background: rgba(0,0,0,0.5);" (click)="closeManualDebitModalVES()">
  <div class="bg-white rounded-2xl shadow-xl max-w-md w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
    <!-- Header -->
    <div style="background: linear-gradient(135deg, #fef2f2, #fee2e2); padding: 20px 24px; border-bottom: 2px solid #fecaca;">
      <h3 class="text-lg font-bold flex items-center gap-2" style="color: #991b1b; margin: 0;">
        <mat-icon style="color: #dc2626; font-size: 24px; width: 24px; height: 24px;">remove_circle</mat-icon>
        Debitar Saldo Manual de VES
      </h3>
    </div>
    <div class="px-6 py-4">
      <div *ngIf="errorMsgVES" class="mb-4 p-3 bg-red-50 border border-red-200 rounded-xl flex items-start gap-2">
        <mat-icon class="text-red-600 text-sm">error</mat-icon>
        <span class="text-red-700 text-sm whitespace-pre-line">{{ errorMsgVES }}</span>
      </div>

      <div class="mb-4 p-3 bg-orange-50 border border-orange-200 rounded-xl flex items-start gap-2">
        <mat-icon class="text-orange-600 text-sm">warning</mat-icon>
        <div class="text-orange-700 text-sm">
          <p class="font-semibold">Esta seguro que desea debitar saldo VES manualmente?</p>
          <p class="text-xs mt-1">Esta accion quitara VES del saldo disponible del usuario y se registrara en el cardex.</p>
        </div>
      </div>

      <div *ngIf="userInfo" class="p-4 rounded-xl border border-gray-200 mb-4" style="background: #f9fafb;">
        <h4 class="text-sm font-bold text-gray-700 mb-3 flex items-center gap-2">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #dc2626;">person</mat-icon>
          Informacion del Usuario
        </h4>
        <div class="text-sm space-y-2">
          <div class="bg-white p-3 rounded-xl border border-red-100">
            <div class="flex items-center gap-2 mb-2">
              <mat-icon class="text-blue-600 text-sm">person</mat-icon>
              <span class="font-semibold text-gray-700">Usuario</span>
            </div>
            <div class="ml-6 space-y-1">
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Nombre:</span>
                <span class="font-medium text-xs">{{ userInfo.nombre || 'N/A' }} {{ userInfo.apellidos || '' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">Email:</span>
                <span class="font-medium text-xs break-all">{{ userInfo.email || 'N/A' }}</span>
              </div>
              <div class="flex items-start">
                <span class="text-gray-600 text-xs w-16">ID:</span>
                <span class="font-mono text-xs text-gray-500">{{ userInfo.usuarioId }}</span>
              </div>
            </div>
          </div>
          <div class="flex justify-between pt-2 border-t">
            <span class="text-gray-600 font-semibold">Saldo Disponible VES:</span>
            <span class="font-bold text-green-600">Bs. {{ saldoVES | number:'1.2-2' }}</span>
          </div>
        </div>
      </div>

      <form [formGroup]="manualDebitFormVES">
        <div class="mb-4">
          <label for="amountDebitVES" class="block text-sm font-medium text-gray-700 mb-2">
            Monto a Debitar (VES) <span class="text-red-500">*</span>
          </label>
          <input
            id="amountDebitVES"
            type="text"
            inputmode="decimal"
            placeholder="Ej: 1000,00"
            class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitFormVES.get('amount')?.invalid && manualDebitFormVES.get('amount')?.touched"
            (input)="onAmountInputDebitVES($event)"
          />
          <div *ngIf="manualDebitFormVES.get('amount')?.invalid && manualDebitFormVES.get('amount')?.touched"
               class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitFormVES.get('amount')?.errors?.['required']">El monto es requerido</span>
            <span *ngIf="manualDebitFormVES.get('amount')?.errors?.['min']">El monto debe ser mayor a 0</span>
            <span *ngIf="manualDebitFormVES.get('amount')?.errors?.['maxDecimals']">El monto solo puede tener hasta 2 decimales</span>
          </div>
          <p class="text-xs text-gray-500 mt-1">Use coma (,) como separador decimal. Maximo 2 decimales.</p>
        </div>

        <div class="mb-4">
          <label for="reasonDebitVES" class="block text-sm font-medium text-gray-700 mb-2">
            Motivo <span class="text-red-500">*</span>
          </label>
          <textarea
            id="reasonDebitVES"
            formControlName="reason"
            rows="3"
            placeholder="Ej: Ajuste por error en deposito, correccion de saldo, retiro no procesado, etc."
            class="w-full px-3 py-2 border border-gray-300 rounded-xl focus:outline-none focus:ring-2 focus:ring-red-500"
            [class.border-red-500]="manualDebitFormVES.get('reason')?.invalid && manualDebitFormVES.get('reason')?.touched"
          ></textarea>
          <div *ngIf="manualDebitFormVES.get('reason')?.invalid && manualDebitFormVES.get('reason')?.touched"
               class="text-red-500 text-xs mt-1">
            <span *ngIf="manualDebitFormVES.get('reason')?.errors?.['required']">El motivo es requerido</span>
            <span *ngIf="manualDebitFormVES.get('reason')?.errors?.['minlength']">El motivo debe tener al menos 10 caracteres</span>
          </div>
        </div>
      </form>
    </div>
    <div class="px-6 py-4 border-t border-gray-200 flex flex-col sm:flex-row justify-center gap-3">
      <button
        type="button"
        (click)="executeManualDebitVES()"
        [disabled]="manualDebitFormVES.invalid || isProcessingDebitVES"
        [style.opacity]="(manualDebitFormVES.invalid || isProcessingDebitVES) ? '0.5' : '1'"
        [style.cursor]="(manualDebitFormVES.invalid || isProcessingDebitVES) ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: #dc2626; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; transition: background 0.2s ease;"
        onmouseover="this.style.background='#b91c1c'" onmouseout="this.style.background='#dc2626'">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: white;" *ngIf="!isProcessingDebitVES">remove_circle</mat-icon>
        <mat-spinner diameter="16" *ngIf="isProcessingDebitVES" class="inline-block"></mat-spinner>
        <span *ngIf="!isProcessingDebitVES">Debitar Saldo</span>
        <span *ngIf="isProcessingDebitVES">Procesando...</span>
      </button>
      <button
        type="button"
        (click)="closeManualDebitModalVES()"
        [disabled]="isProcessingDebitVES"
        [style.opacity]="isProcessingDebitVES ? '0.5' : '1'"
        [style.cursor]="isProcessingDebitVES ? 'not-allowed' : 'pointer'"
        style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 24px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; transition: all 0.2s ease;"
        onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
        <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">cancel</mat-icon>
        Cancelar
      </button>
    </div>
  </div>
</div>
